export default __webpack_public_path__ + "image-distributea84009.png";